import BaseException from './BaseException';

export default class LoopHttpException extends BaseException {}
